import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './customer/Home';
import Login from './customer/login';
import Blog from './customer/blog';
import AdminStaff from './manager/adminmanager';
import StaffDetails from './manager/staffdetails';
import Chat from './manager/ChatDashboard';
import TaskManager from './manager/taskmanager';
import Training from './manager/traininghome';
import TrainingDoc from './manager/trainingdocbuilder';
import BookShifts from './manager/bookshifts';
import Holiday from './manager/holidayapprove';
import Calendar from './manager/calendar';
import CreateMeeting from './manager/createmeeting';
import MeetingCalendar from './manager/meetingscalendar';
import Meetings from './manager/meeting';
import NoteTaker from './manager/notetakerbrowser';
import Shifts from './manager/shifts';
import StaffActions from './manager/staffactions';
import ShiftHome from './manager/shifthome';
import ManagerNav from './manager/managernav';
import CreateAppraisal from './manager/createapraisal';
import EditAppraisal from './manager/editappraisal';
import Users from './manager/userhome';
import StaffDash from './staff/staffdash';
import StaffNav from './staff/staffnav';
import StaffHoliday from './staff/staffholiday';
import Profile from './staff/myprofile';
import Pricing from './customer/pricing';
import Waitlist from './customer/waitlist';
import Verification from './manager/verification';
import Onboarding from './manager/onboardinghome';
import NewUser from './manager/newuser';
import OrganizationalTree from './manager/organisationtree';
import ProfilePage from './staff/profilepage';
import CourseMessage from './manager/coursemessage';
import Datalayer from './manager/datalayer';

import { AuthContext } from './AuthContext';
import { useContext } from 'react';
import Logout from './manager/logout';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import StaffVerification from './manager/staffverification';
import { Navigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import TaskCalendar from './manager/taskcalendarbuild';
import TaskCalendarTeam from './manager/taskcalendarteam';
import QuizBuilder from './manager/quizbuilder';
import TrainingStats from './manager/trainingstats';
import AdminDocs from './manager/currenttask';
import Members from './manager/members';
import KnowledgeTree from './manager/sharkopedia';
import Reports from './manager/reports';
import OvertimeManager from './manager/overtimemanager';
import ProcessCreator from './manager/processcreator';
import TaskTraining from './manager/tasktraining';
import CreateProject from './manager/createproject';
import BrainstormPage from './manager/BrainstormPage';
import Billing from './manager/billing';
import StaffProject from './staff/staffproject';
import BackToWorkForm from './manager/backtoworkform';
import BackToWorkDashboard from './manager/backtoworkdashboard';
import Witness from './staff/witness';
import MFA from './customer/mfa';
import ForgotPassword from './customer/forgotpassword';
import PDFScanner from './manager/pdfscanner';
import VisitorLogin from './customer/visitorlogin';
import InterviewMeeting from './manager/interviewmeeting';
import LoggedOut from './manager/loggedout';
import PaymentTrial from './customer/paymenttrial';
import LoginPasswordForgot from './customer/loginpasswordforgot';
import MobileLogin from './customer/mobilelogin';
import SicknessReport from './manager/sicknessreport';
import VideoScreen from './manager/VideoScreen';
import Docs from './docs/Home'
import AdminInteractions from './manager/admininteractions';
import ServerDown from './customer/404';
import Assessments from './manager/assessment';
import TrainingBook from './manager/trainingbook';
import ProjectFinancials from './manager/projectfinancials';
import CustomerInvoice from './customer/customerinvoice';
import StandbyResponse from './customer/standbyresponse';
import Finances from './manager/finances';
import SalesBook from './manager/salesbook';
import AiTokenPayment from './manager/AiTokenPayment';
import TrialPaymentSuccess from './customer/TrialPaymentSuccess';
import OnboardStaff from './staff/onboardstaff';
import Avenor from './manager/avenor';
import HolidayBook from './manager/holidaybook';
import HeavyAiJobProgress from './manager/heavyaijobprogress';
import AvenorJobProgress from './manager/avenorjobprogress';
import OverwrittenTasks from './manager/overwrittentasks';
import { TrainingDocPage } from './manager/onboardinghome';
import CustomersCRMPanel from './manager/customercrm';









export default function App() {
  const navigate = useNavigate();
  const user = useContext(AuthContext);
  const location = useLocation();
  



  useEffect(() => {
    const STALE_MS = 2 * 60 * 1000; // 2 minutes
    const RELOAD_COOLDOWN_MS = 60 * 1000; // prevent reload loops
    const LAST_ACTIVE_KEY = 'lastActiveAtInsightOs';
    const LAST_RELOAD_KEY = 'lastReloadAtInsightOs';
    let scheduled = false;

    const markActive = () => {
      localStorage.setItem(LAST_ACTIVE_KEY, String(Date.now()));
    };

    const shouldReload = () => {
      const now = Date.now();
      const lastActive = Number(localStorage.getItem(LAST_ACTIVE_KEY) || '0');
      const lastReload = Number(sessionStorage.getItem(LAST_RELOAD_KEY) || '0');
      const isStale = now - lastActive > STALE_MS;
      const inCooldown = now - lastReload < RELOAD_COOLDOWN_MS;
      return isStale && !inCooldown;
    };

    const triggerReload = () => {
      if (scheduled) return;
      if (!shouldReload()) return;
      scheduled = true;
      sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()));
      window.location.reload();
    };

    const handleVisibilityOrFocus = () => {
      if (document.visibilityState === 'visible') {
        triggerReload();
      } else {
        markActive();
      }
    };

    const activityEvents = ['click', 'keydown', 'mousemove', 'scroll', 'touchstart'];
    activityEvents.forEach((evt) => window.addEventListener(evt, markActive, { passive: true }));
    document.addEventListener('visibilitychange', handleVisibilityOrFocus);
    window.addEventListener('focus', handleVisibilityOrFocus);

    markActive();

    return () => {
      activityEvents.forEach((evt) => window.removeEventListener(evt, markActive));
      document.removeEventListener('visibilitychange', handleVisibilityOrFocus);
      window.removeEventListener('focus', handleVisibilityOrFocus);
    };
  }, []);

  // If user is null (not loaded yet), show nothing or a spinner
  if (user === null) {
    // Only allow public routes if user is not loaded
    if (
      window.location.pathname === "/" ||
      window.location.pathname === "/verification" ||
      window.location.pathname.startsWith("/verification/") ||
      window.location.pathname === "/forgotlink" ||
      window.location.pathname === "/forgotpassword" ||
      window.location.pathname === "/videoscreen" ||
      window.location.pathname === "/staffverification" ||
      window.location.pathname.startsWith("/staffverification/") ||
      window.location.pathname === "/404" ||
      window.location.pathname === "/loggedout" ||
      window.location.pathname === "/mfa" ||
      window.location.pathname === "/paymenttrial" ||
      window.location.pathname.startsWith("/mobilelogin/") ||
      window.location.pathname.startsWith("/notetaker/") ||
      window.location.pathname.startsWith("/standby/") ||
      window.location.pathname.startsWith("/invoice/")
    ) {
      return (
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/forgotlink" element={<LoginPasswordForgot />} />
              <Route path="/forgotpassword" element={<ForgotPassword />} />
          <Route path="/verification" element={<Verification />} />
                  <Route path="/verification/:token" element={<Verification />} />
          <Route path="/videoscreen" element={<VideoScreen />} />
                <Route path="/404" element={<ServerDown />} />
          <Route path="/staffverification" element={<StaffVerification />} />
                  <Route path="/staffverification/:token" element={<StaffVerification />} />
          <Route path="/notetaker/:id" element={<NoteTaker />} />
          <Route path="/paymenttrial" element={<PaymentTrial />} />
          <Route path="/mobilelogin/:tempcode/:id" element={<MobileLogin />} />
          <Route path="/invoice/:id" element={<CustomerInvoice />} />
          <Route path="/standby/:token/:action" element={<StandbyResponse />} />
          <Route path="/loggedout" element={<LoggedOut />} />
          <Route path="/mfa" element={<MFA />} />
        </Routes>
      );
    }
    return null;
  }

  // If user is not authenticated (no id/email), redirect to login except for public routes
  useEffect(() => {
    const publicRoutes = ["/", "/verification", "/404", "/staffverification", "/loggedout", "/paymenttrial", "/forgotlink", "/forgotpassword", "/mobilelogin", "/mfa"];
    const isPublicRoute =
      publicRoutes.includes(location.pathname) ||
      location.pathname.startsWith("/verification/") ||
      location.pathname.startsWith("/staffverification/") ||
      location.pathname.startsWith("/mobilelogin/") ||
      location.pathname.startsWith("/notetaker/") ||
      location.pathname.startsWith("/standby/") ||
      location.pathname.startsWith("/invoice/");
    if (!user?.id && !isPublicRoute) {
      navigate("/", { replace: true });
    }
  }, [user, location, navigate]);

  // MFA and ForgotPassword: allow if user.temp is true or user.mfaRequired is true
  const allowMFA = !!(user?.temp || user?.mfaRequired);
  const allowForgot = !!user?.temp;





  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<Login />} />
      <Route path="/forgotlink" element={<LoginPasswordForgot />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/verification" element={<Verification />} />
      <Route path="/verification/:token" element={<Verification />} />
      <Route path="/videoscreen" element={<VideoScreen />} />
      <Route path="/404" element={<ServerDown />} />
      <Route path="/staffverification" element={<StaffVerification />} />
      <Route path="/staffverification/:token" element={<StaffVerification />} />
      <Route path="/notetaker/:id" element={<NoteTaker />} />
      <Route path="/loggedout" element={<LoggedOut />} />
      <Route path="/mfa" element={<MFA />} />
              <Route path="/paymenttrial" element={<PaymentTrial />} />
            <Route path="/mobilelogin/:tempcode/:id" element={<MobileLogin />} />
      <Route path="/invoice/:id" element={<CustomerInvoice />} />
            <Route path="/standby/:token/:action" element={<StandbyResponse />} />


      {/* MFA and ForgotPassword routes */}
      {allowForgot && <Route path="/forgotpassword" element={<ForgotPassword />} />}


 

      {/* only allow if admin and manager and trial is null or 1 */}
      {/* {(user.access === 'rota-manager') && (
        <>
      {/*   <Route path="/rota-home" element={<RotaHome />} />
        </> 
      // )} */}
      {(user.access === 'admin' || user.access === 'manager') && (
        <>
          <Route path="/dashboard" element={<AdminStaff />} />
          <Route path="/staffdetails" element={<StaffDetails />} />
          <Route path="/chatdashboard" element={<Chat />} />
          <Route path="/taskmanager" element={<TaskManager />} />
          <Route path="/finances" element={<Finances />} />
          <Route path="/analytics" element={<Navigate to="/finances" replace />} />
          <Route path="/training" element={<Training />} />
          <Route path="/trainingdocbuilder" element={<TrainingDoc />} />
          <Route path="/bookshifts" element={<BookShifts />} />
          <Route path="/holiday" element={<Holiday />} />
          <Route
            path="/managerholiday"
            element={
              <>
                <ManagerNav />
                <Holiday />
              </>
            }
          />
          <Route path="/bookholiday" element={<HolidayBook holiday={[]} />} />
          <Route path="/data-layer" element={<Datalayer />} />
          <Route path="/calendars" element={<Calendar />} />
          <Route path="/createmeeting" element={<CreateMeeting />} />
          <Route path="/customercrm" element={<CustomersCRMPanel />} />
          <Route path="/meetingscalendar" element={<MeetingCalendar />} />
          <Route path="/meeting" element={<Meetings />} />
          <Route path="/shifts" element={<Shifts />} />
          <Route path="/clockins" element={<StaffActions />} />
          <Route path="/shifthome" element={<ShiftHome />} />
          <Route path="/appraisals" element={<CreateAppraisal />} />
          <Route path="/viewappraisal" element={<EditAppraisal />} />
          <Route path="/users" element={<Users />} />
          <Route path="/myprofile" element={<Profile />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/newuser" element={<NewUser />} />
          <Route path="/organizationaltree" element={<OrganizationalTree />} />
          <Route path="/profilepage" element={<ProfilePage />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/course" element={<CourseMessage />} />
          <Route path="/taskcalendar" element={<TaskCalendar />} />
          <Route path="/team-tasks" element={<TaskCalendarTeam />} />
          <Route path="/quiz-builder" element={<QuizBuilder />} />
          <Route path="/training-stats" element={<TrainingStats />} />
          <Route path="/admin-tasks" element={<AdminDocs />} />
          <Route path="/team-members" element={<Members />} />
          <Route path="/knowledge-tree" element={<KnowledgeTree />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/overtime-manager" element={<OvertimeManager />} />
          <Route path="/overwritten-tasks" element={<OverwrittenTasks />} />
          <Route path="/process-creator" element={<ProcessCreator />} />
          <Route path="/bottleneck-analysis" element={<TaskTraining />} />
          <Route path="/project-management" element={<CreateProject />} />
          <Route path="/training-doc/:stepNumber" element={<TrainingDocPage />} />

          <Route path="/brainstorm" element={<BrainstormPage />} />
          <Route path="/job-progress/:jobId" element={<HeavyAiJobProgress />} />
          <Route path="/avenorloading/leads/:jobId" element={<AvenorJobProgress queueType="leads" />} />
          <Route path="/avenorloading/advert/:jobId" element={<AvenorJobProgress queueType="advert" />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/aitokenpayment/:amount" element={<AiTokenPayment />} />
          <Route path="/trial-payment-success/:stripesubscriptionid" element={<TrialPaymentSuccess />} />
          <Route path='/recruitment' element={<PDFScanner />} />
          <Route path="/back-to-work" element={<BackToWorkForm />} />
          <Route path="/backtoworkdashboard" element={<BackToWorkDashboard />} />
          <Route path="/witnessstatement" element={<Witness />} />
          <Route path="/visitorlogin" element={<VisitorLogin />} />
          <Route path="/interview" element={<InterviewMeeting />} />
          <Route path="/sickai" element={<SicknessReport />} />
          <Route path="/support" element={<Docs />} />
          <Route path="/onboardstaff" element={<OnboardStaff />} />
          <Route path="/productivity-insights" element={<AdminInteractions />} />
          <Route path="/assessments" element={<Assessments />} />
          <Route path="/book-training" element={<TrainingBook />} />
          <Route path="/sales-training" element={<SalesBook />} />
          <Route path="/avenor" element={<Avenor />} />

          <Route path="/project-financials" element={<ProjectFinancials />} />



        </>
      )}

      {/* Staff routes */}
      {user.access === 'staff' && (
        <>
          <Route path="/staffdash" element={<StaffDash />} />
          <Route path="/course" element={<CourseMessage />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/myprofile" element={<Profile />} />
          <Route path="/chatdashboard" element={<Chat />} />
          <Route path="/training" element={<Training />} />
          <Route path="/staff-project" element={<StaffProject />} />
          <Route
            path="/staffholiday"
            element={
              <>
                <StaffNav />
                <StaffHoliday />
              </>
            }
          />
          <Route path="/bookholiday" element={<HolidayBook holiday={[]} />} />
          <Route path="/admin-tasks" element={<AdminDocs />} />
          <Route path="/back-to-work" element={<BackToWorkForm />} />
          <Route path="/witnessstatement" element={<Witness />} />
          <Route path="/knowledge-tree" element={<KnowledgeTree />} />
          <Route path="/sickai" element={<SicknessReport />} />
          <Route path="/organizationaltree" element={<OrganizationalTree />} />
          <Route path="/sickai" element={<SicknessReport />} />
          <Route path="/support" element={<Docs />} />
          <Route path="/onboardstaff" element={<OnboardStaff />} />
          <Route path="/customercrm" element={<CustomersCRMPanel />} />
          <Route path="/avenor" element={<Avenor />} />




        </>
      )}
      

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}






